import React from 'react';
import { GeoJSONLayer, Layer } from 'react-mapbox-gl';

export const ClusterLayer = ({ id, layer }) => (
  <div>
    <GeoJSONLayer
      id={id}
      key={id}
      sourceOptions={{
        cluster: true,
        clusterMaxZoom: 14,
        clusterRadius: 5,
        clusterProperties: {
          [id]: ['max', ['get', id]],
        },
      }}
      paint={layer.style.paint}
      data={layer.geojson}
    />
    <Layer
      type={layer.style.type}
      sourceId={id}
      id={`clustered-${id}`}
      key={`clustered-${id}`}
      paint={layer.style.paint}
      filter={['has', 'point_count']}
    />
    <Layer
      type={layer.style.type}
      sourceId={id}
      key={`unclustered-${id}`}
      id={`unclustered-${id}`}
      paint={layer.style.paint}
      filter={['!', ['has', 'point_count']]}
    />
  </div>
);
